// src/components/VideoLogin.jsx 
import React, { useState, useEffect } from "react"; 
import { useNavigate } from "react-router-dom"; 
const VideoLogin = () => { 
  const navigate = useNavigate(); 
  const [username, setUsername] = useState(""); 
  const [password, setPassword] = useState(""); 
  const [remember, setRemember] = useState(false); 
  const [showPassword, setShowPassword] = useState(false); 
  const [error, setError] = useState(""); 
  const [loading, setLoading] = useState(false); 
  const [showSuccess, setShowSuccess] = useState(false); 
  
  // keep compatibility with existing client-side checks that rely on these flags 
  
  const setDemoAuthFlags = () => { 
    localStorage.setItem("videoKyc_logged_in", "1"); 
    localStorage.setItem("videoKyc_token", "demo_token_for_video_kyc"); 
    localStorage.setItem("user_logged_in", "1"); 
    
    // IMPORTANT: set sessionStorage isAuthenticated so RequireVideoAuth passes 
    
    try { 
      sessionStorage.setItem("isAuthenticated", "true"); 
    } catch (e) { 
      // ignore if sessionStorage unavailable for any reason 
      console.warn("Could not set sessionStorage isAuthenticated", e); 
    } 
    
    if (remember){ 
        localStorage.setItem("videoKyc_remember", "1"); 
      } else { 
        localStorage.removeItem("videoKyc_remember"); 
      } 
    }; 
    
    // Auto-redirect if already logged in (so visiting /video-login while authenticated goes to /home) 
    
    useEffect(() => { 
      try { 
        if (sessionStorage.getItem("isAuthenticated") === "true") { 
          navigate("/home", { replace: true }); 
        } 
      } catch (e) { 
        // ignore 
        console.warn("sessionStorage read failed", e); 
      } 
    }, [navigate]); 
    
    const API_BASE = process.env.REACT_APP_API_BASE || ""; 
    const handleSubmit = async (e) => { 
      e.preventDefault(); 
      setError(""); 
      
      if (!username.trim()) return setError("Enter username"); 
      if (!password) return setError("Enter password"); 
      
      setLoading(true); 
      
      try { 
        const res = await fetch(`${API_BASE}/api/auth/login`, { 
          method: "POST", 
          headers: { 
            "Content-Type": "application/json", 
          }, 
          credentials: "include", // important: allow backend to set HttpOnly cookie 
          body: JSON.stringify({ username: username.trim(), password }), 
        }); 
        
        const data = await res.json().catch(() => ({})); 
        
        if (res.ok) { 
          // Server logged in and set cookie — set local/session compatibility flags and show success 
          setDemoAuthFlags(); setShowSuccess(true); 
        } else { 
          // show server-provided message or fallback 
          setError(data?.error || data?.message || "Invalid credentials. Try again."); 
        } 
      } catch (err) { 
        console.error("Login error:", err); 
        setError("Login failed. Check network and try again."); 
      } finally { 
        setLoading(false); 
      } 
    }; 
    
    return ( 
    <div className="login-wrapper">
    <div className="login-card">
      <div className="text-center mb-5"> 
        <img src="/kfd.png" alt="logo" className="mx-auto w-20 h-20 object-contain opacity-90" /> 
        <h2 className="text-2xl font-extrabold text-purple-700 mt-3">Video KYC — Admin Login</h2> 
        <p className="text-sm text-gray-500 mt-1">Sign in to start the KYC survey</p> 
      </div> 
      
      <form onSubmit={handleSubmit} className="space-y-4"> 
        <div> 
          <label className="block text-sm font-medium">Username</label> 
          <input 
          type="text" 
          value={username} 
          onChange={(e) => setUsername(e.target.value)} 
          className="mt-1 block w-full rounded-lg border px-3 py-2 focus:ring-2 focus:ring-purple-300" 
          placeholder="Username" 
          /> 
        </div> 
        
        <div> 
          <label className="block text-sm font-medium">Password</label> 
          <div className="relative mt-1"> 
            <input type={showPassword ? "text" : "password"} 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
            className="block w-full rounded-lg border px-3 py-2 pr-14 focus:ring-2 focus:ring-purple-300" 
            placeholder="Password" 
          /> 
          
          <button 
          type="button" 
          className="absolute right-3 top-1/2 -translate-y-1/2 text-xs" 
          onClick={() => setShowPassword(!showPassword)} 
          > 
          {showPassword ? "Hide" : "Show"} 
          </button> 
        </div>    
      </div> 

      <div className="flex items-center justify-between"> 
        <label className="inline-flex items-center text-sm text-purple-600"> 
          <input 
          type="checkbox" 
          checked={remember} 
          onChange={(e) => setRemember(e.target.checked)} 
          className="mr-2" /> 
          Remember me 
          </label> 

          <button 
          type="button" 
          className="text-sm text-purple-600"
        > 
        Forgot? 
      </button> 
      </div> 
      
      {error && <div className="text-sm text-red-600">{error}
      </div>} 
      
      <button
      type="submit"
      disabled={loading}
      className="btn-black w-full"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/Black2.png)`,
        padding: "14px",
        color: "#fff",
      }}
    >
      {loading ? "Signing in..." : "Sign in"} 
      </button> 
    </form> 
  </div> 
  
  {showSuccess && ( <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50"> 
  <div className="bg-white p-6 rounded-xl shadow-xl text-center max-w-sm w-full"> 
    <h2 className="text-xl font-bold text-green-700 mb-3">Successfully Logged In!</h2> 
    <p className="text-gray-700 mb-4">Click OK to continue.</p> 

    <button
    onClick={() => navigate("/home", { replace: true })}
    className="btn-white"
    style={{
      backgroundImage: `url(${process.env.PUBLIC_URL}/White2.png)`,
      padding: "12px 32px",
      color: "#000",
    }}
  >
    OK 
    </button> 
  </div> 
  </div> 
  )} 
  </div> 
  ); 
}; 

export default VideoLogin;